const NivelUsuario = ({ nivel, pontos, tipo}) => {
    function formataNivelLowerCase(nivel) {
      const nivelFormatado = nivel ? nivel.toLowerCase() : 'e';
      return nivelFormatado;
    }
    const nivelClass = `border-geral-${formataNivelLowerCase(nivel)}`;
    
  
    return (
      <div className="nivel-geral-card">
        <div className="inline-block">
          <div className={nivelClass}>
            <div className="box">
              <p className="font-medium text-lg pb-1">{tipo}</p>
              <p className="font-semibold text-[90px] leading-none pb-1">{nivel}</p>
              {pontos && <p className="pontos">{pontos}</p>}
            </div>
          </div>
        </div>
      </div>
    );
  };

export default NivelUsuario